/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_INACTIVE_BOXES = gql`
  query GetInactiveBoxes(
    $filter: InActiveBoxFilterInput
    $options: GetManyOptions
  ) {
    getInactiveBoxes(filter: $filter, options: $options) {
      content {
        _id
        amountPaid
        costumeID
        amountPaidInUSD
        totalAmountInUSD
        totalAmount
        user {
          fullName
          email
          gender
          creatorUser {
            email
            fullName
            id
          }
        }
        delivery {
          isOpted
          partner
          status
          trackingId
        }
        paymentStats
        presentation {
          id
          name
          status
          year
        }
        section {
          costumeTypes {
            name
            id
          }
          id
          name
          maxInvites
        }
        isVIP
        items {
          costumeType {
            name
            description
            images
            minDownPayment
          }
          costumeFeature {
            id
            name
          }
          costumeAttribute {
            id
            name
          }
          costumeValue {
            id
            name
            topupPrice
            images
          }
        }
        boxTxes {
          action
          actionContent
          box
          createdAt
          displayTitle
          user {
            vuid
            firstName
            lastName
            email
          }
          reason
        }
        referal {
          inviteType
          partition
          sectionOptType
          id
        }
        inactive {
          reason
          type
          user {
            email
            fullName
          }
        }
      }
      count
      limit
      skip
      sort {
        field
        order
      }
    }
  }
`;
